/* eslint-disable */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  Box,
  Typography,
  CircularProgress
} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';

import KwVolumeCategoryForm from 'components/molecules/market/KwVolumeCategoryForm';
import {
  currentKwVolumeAmazonCategoryList,
  resetKwVolAmazonPicker
} from 'feactures/categoryKeywordVolume/categoryKeywordVolumeSlice';

/**
 * @param {boolean} inline — true のときカテゴリ1〜6をその場に表示（親モーダル内用）。デフォルトは従来どおりボタン→内側ダイアログ。
 */
export default function KwVolumeCategoryPickerPane({
  categories,
  comboGrayscaleIds,
  pickerInitialLoading = false,
  inline = false
}) {
  const dispatch = useDispatch();
  const [innerOpen, setInnerOpen] = useState(false);
  const selectedPath = useSelector(currentKwVolumeAmazonCategoryList);

  const pathLabels = (Array.isArray(selectedPath) ? selectedPath : [])
    .filter((x) => x && x.label && x.value)
    .map((x) => x.label);
  const buttonText =
    pathLabels.length > 0
      ? pathLabels[pathLabels.length - 1]
      : 'カテゴリを選択する';

  const handleClickOpen = () => {
    setInnerOpen(true);
  };

  /** KW 専用スライスのみ。お気に入り／親お気に入りは市場モーダルと共有しない */
  const handleReset = () => {
    dispatch(resetKwVolAmazonPicker());
  };

  const handleCancel = () => {
    handleReset();
    setInnerOpen(false);
  };

  const handleOk = () => {
    setInnerOpen(false);
  };

  const cat1Ready =
    categories &&
    Array.isArray(categories.category1) &&
    categories.category1.length > 0;
  const busyInline = !categories || (!cat1Ready && pickerInitialLoading);
  const busyButtonMode = !categories || !cat1Ready;

  const formBlock = (
    <>
      <KwVolumeCategoryForm
        categories={categories}
        comboGrayscaleIds={comboGrayscaleIds}
      />
    </>
  );

  if (inline) {
    return (
      <Box sx={{ overflow: 'hidden' }}>
        {busyInline ? (
          <Box display="flex" alignItems="center" gap={1} py={0.5}>
            <CircularProgress size={20} />
            <Typography variant="caption" color="text.secondary">
              読み込み中…
            </Typography>
          </Box>
        ) : (
          formBlock
        )}
      </Box>
    );
  }

  return (
    <>
      <LoadingButton
        onClick={handleClickOpen}
        variant="outlined"
        size="small"
        loading={busyButtonMode}
        disabled={busyButtonMode}
        sx={{
          backgroundColor: '#FFFFFF',
          borderColor: '#BDBDBD',
          fontSize: '14px',
          minWidth: '150px',
          width: '250px',
          height: '30px'
        }}
        color="inherit"
      >
        <Typography
          sx={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            fontSize: '14px'
          }}
        >
          {buttonText}
        </Typography>
      </LoadingButton>

      <Dialog open={innerOpen} onClose={handleOk} maxWidth="md" fullWidth>
        <DialogTitle>カテゴリを選択する</DialogTitle>
        <Box px="40px" pt="20px">
          <Typography fontSize="12px">
            一部カテゴリはグレーダウンされ、選択不可となっています。
            <br />
            データが充実次第、段階的に利用可能になります。
          </Typography>
        </Box>
        <DialogContent sx={{ pt: '0' }}>{formBlock}</DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleOk} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
